// extracted by mini-css-extract-plugin
export default {"infoContainer":"Info_infoContainer__oxZ8U","title":"Info_title__80QFl","description":"Info_description__4BBAy","profileImage":"Info_profileImage__5+5ue"};